var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0008 8.11328C9.84044 8.11328 8.08984 9.85295 8.08984 12C8.08984 14.1463 9.84063 15.8858 12.0008 15.8858C14.1612 15.8858 15.9128 14.1462 15.9128 12C15.9128 9.85307 14.1614 8.11328 12.0008 8.11328ZM12.0005 9.60369C13.3327 9.60369 14.4125 10.6763 14.4125 12.0001C14.4125 13.323 13.3325 14.3955 12.0005 14.3955C10.6687 14.3955 9.58949 13.3233 9.58949 12.0001C9.58949 10.6761 10.6686 9.60369 12.0005 9.60369Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2882 4.00482L12.002 4C7.86108 4 4.12926 6.92308 2.06091 11.7058C1.9797 11.8936 1.9797 12.1064 2.06091 12.2942L2.20424 12.6168C4.24638 17.0931 7.77544 19.8644 11.7118 19.9952L11.998 20C16.1389 20 19.8707 17.0769 21.9391 12.2942C22.0213 12.104 22.0203 11.8884 21.9361 11.699L21.7968 11.3856C19.7497 6.90091 16.2192 4.13547 12.2882 4.00482ZM12.0093 5.48926L12.2483 5.4944L12.5153 5.50829C15.7125 5.73468 18.6529 8.10537 20.4293 11.9989L20.42 12.023C18.599 16.0003 15.5573 18.3851 12.2592 18.5048L12.0043 18.5086L11.7472 18.5052L11.4809 18.4913C8.38303 18.2719 5.52669 16.0342 3.73946 12.3595L3.57031 11.9989L3.72689 11.666C5.61149 7.77298 8.69179 5.49011 12.0093 5.48926Z",
    fill: "#3D3D3D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpen);
export default __webpack_public_path__ + "static/media/eyeOpen.bc53bcbc.svg";
export { ForwardRef as ReactComponent };